import Icon from '../components/Icon.vue'

Icon.register({
  'mars-stroke-v': {
    width: 288,
    height: 512,
    paths: [
      {
        d: 'M245.8 234.2c56.3 56.2 56.3 147.4 0 203.6-56.2 56.2-147.4 56.2-203.6 0s-56.2-147.4 0-203.6c19.9-19.9 44.2-32.8 69.8-38.6v-25.4h-20c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h20v-24.7h-23.9c-10.7 0-16.1-12.9-8.5-20.5l55.9-55.9c4.7-4.7 12.3-4.7 17 0l55.9 55.8c7.5 7.6 2.2 20.5-8.5 20.5h-23.9v24.8h20c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-20v25.4c25.6 5.8 49.9 18.7 69.8 38.6zM200.6 392.6c31.2-31.2 31.2-82 0-113.1-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1c31.2 31.2 81.9 31.2 113.1 0z'
      }
    ]
  }
})
